const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const registrarEntradaInsumos = async (data) => {
  try {
    const response = await fetch(`${API_URL}/movimientos-insumos/registrar-entrada`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('Error al registrar entrada');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en registrarEntradaInsumos:', error);
    throw error;
  }
};

export const fetchMovimientosInsumos = async (filters = {}) => {
  try {
    const response = await fetch(`${API_URL}/movimientos-insumos/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });

    if (!response.ok) {
      throw new Error('Error al obtener movimientos');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchMovimientosInsumos:', error);
    throw error;
  }
};

export const fetchInventarioActualInsumos = async (filters = {}) => {
  try {
    const response = await fetch(`${API_URL}/movimientos-insumos/inventario/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });

    if (!response.ok) {
      throw new Error('Error al obtener inventario actual');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchInventarioActualInsumos:', error);
    throw error;
  }
};

export const ajustarInsumo = async (data) => {
  try {
    const response = await fetch(`${API_URL}/movimientos-insumos/ajustar`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error('Error al ajustar inventario');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en ajustarInsumo:', error);
    throw error;
  }
};

export const fetchMovimientoById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/movimientos-insumos/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al obtener movimiento');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchMovimientoById:', error);
    throw error;
  }
};
